/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, address: NonNullable<unknown> }} Chat_Tool_Confirm_Acting_On_NamedInputs */



/**
* | output |
* | --- |
* | "From {name} ({address})" |
*
* @param {Chat_Tool_Confirm_Acting_On_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_acting_on_named = /** @type {((inputs: Chat_Tool_Confirm_Acting_On_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Acting_On_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Von ${i?.name} (${i?.address})`)
	return /** @type {LocalizedString} */ (`From ${i?.name} (${i?.address})`)
});